import React from 'react';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { FUEL_TYPE_ELECTRICITY, FUEL_TYPE_GAS } from '../../config/AppConfigurator';

/* IMPORTING FOOTER STYLES */
import '../../assets/components/Footer.scss';

export const Footer = ({ }) => {
    const navigate  = useNavigate();
    const location = useLocation();

    const QuerySelectionFactory = (e, fuelType) => {
        e.preventDefault();
        /* Using Factory Pattern to switch between the containers on the basis of fuel type selected */
          switch(fuelType){
            case FUEL_TYPE_ELECTRICITY:
              navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_ELECTRICITY } });
              break;
            case FUEL_TYPE_GAS:
              navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_GAS } });
              break;
            default:
              navigate('/');
          }
      };

    return (
        <>
        { location.pathname !== "/" &&
            <>
                <footer className="footer-section">
                    <div className="copyright-area footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 text-center text-lg-left">
                                    <div className="copyright-text">
                                        <p>Copyright &copy; {moment().format('YYYY')}, All Right Reserved Home</p>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 text-center text-lg-right d-none d-lg-block">
                                    <div className="footer-menu">
                                        <ul>
                                            <li><a onClick={(e)=>QuerySelectionFactory(e, FUEL_TYPE_ELECTRICITY)} href="#">Enquire Domestic Electricity</a></li>
                                            <li><a onClick={(e)=>QuerySelectionFactory(e, FUEL_TYPE_GAS)} href="#">Enquire Domestic Gas</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        }
        </>
    );
};
